import React from "react";
import { cn } from "../../lib/utils";

const Button = React.forwardRef(({ 
  className, 
  variant = "primary", 
  size = "default", 
  children, 
  ...props 
}, ref) => {
  const baseStyles = "inline-flex items-center justify-center rounded-lg font-heading text-sm font-semibold transition-all duration-200 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring disabled:pointer-events-none disabled:opacity-50";
  
  const variants = {
    primary: "bg-gradient-to-b from-yellow-600 to-yellow-800 hover:from-yellow-500 hover:to-yellow-700 text-black gold-glow",
    secondary: "border border-purple-700 text-purple-200 hover:bg-purple-950/50 bg-transparent",
    destructive: "text-ruby border border-ruby/50 hover:bg-ruby/10 bg-transparent",
    combat: "bg-gradient-to-b from-red-900/60 to-red-950/80 border border-ruby/50 text-yellow-100",
    arcane: "bg-gradient-to-b from-purple-700 to-purple-900 arcane-glow text-white",
    ghost: "hover:bg-accent hover:text-accent-foreground"
  };
  
  const sizes = {
    default: "h-10 px-6 py-2",
    sm: "h-8 px-4 text-xs",
    lg: "h-12 px-8 text-base",
    icon: "h-10 w-10"
  };
  
  return (
    <button
      className={cn(baseStyles, variants[variant], sizes[size], className)}
      ref={ref}
      {...props}
    >
      {children}
    </button>
  );
});

Button.displayName = "Button";

export default Button;
